(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog-posts"] && !Shopify.designMode) return;
  try {
    
  const initializeFeaturedBlogControls = (section) => {
    const controls = section.querySelector('[data-featured-blog-controls]');
    const previous = section.querySelector('[data-featured-blog-previous]');
    const next = section.querySelector('[data-featured-blog-next]');
    const slideshow = section.querySelector('.hidden--desktop.resource-list__carousel slideshow-component');

    if (!controls || !previous || !next || !slideshow) return;
    if (controls.dataset.initialized === 'true') return;

    controls.dataset.initialized = 'true';

    const getSlides = () => slideshow.slides || slideshow.refs?.slides || [];

    const update = () => {
      const slides = getSlides();
      const hasOverflow = slides.length > 1;

      controls.hidden = !hasOverflow;
      previous.disabled = !hasOverflow || slideshow.previousIndex < 0;
      next.disabled = !hasOverflow || slideshow.nextIndex >= slides.length;
    };

    previous.addEventListener('click', () => {
      if (!previous.disabled && typeof slideshow.previous === 'function') {
        slideshow.previous();
      }
    });

    next.addEventListener('click', () => {
      if (!next.disabled && typeof slideshow.next === 'function') {
        slideshow.next();
      }
    });

    slideshow.addEventListener('slideshow:select', update);
    slideshow.refs?.scroller?.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update, { passive: true });

    const observer = new MutationObserver(update);
    observer.observe(slideshow, { attributes: true, childList: true, subtree: true });

    requestAnimationFrame(update);
    window.setTimeout(update, 350);
  };

  const initializeAllFeaturedBlogControls = () => {
    document.querySelectorAll('.featured-blog-posts').forEach(initializeFeaturedBlogControls);
  };

  if (customElements.get('slideshow-component')) {
    initializeAllFeaturedBlogControls();
  } else {
    customElements.whenDefined('slideshow-component').then(initializeAllFeaturedBlogControls);
  }

  document.addEventListener('shopify:section:load', initializeAllFeaturedBlogControls);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
